import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext'
import generateUUID from 'Utils/generateUUID'
import { useSelector } from 'react-redux'
import { formatToCents } from 'Utils/convertPoints'
import { deleteCookie, getCookie } from 'Utils/handleCookie'

const CreateBraspagInput = ({
  customer,
  billingAddress,
  paymentPoints,
  debitCard,
  setIsLoadingBraspagInput,
  setIsLoadingBraspagConfirmationModal,
  handleShowError,
  handlePurchaseDebit,
}) => {
  const [accessToken, setAccessToken] = useState(null)
  const [ipAddress, setIpAddress] = useState(null)
  const [isBraspagAuthorizeError, setIsBraspagAuthorizeError] = useState(false)

  let bpContainerAuthenticate = document.createElement('div')
  bpContainerAuthenticate.setAttribute('id', 'bp_container_authenticate')

  const phoneNumber = customer.phone || ''
  const formatToCent = formatToCents(paymentPoints || 0)

  const validityDateParts = debitCard.validityDate.split('/')
  const expirationMonth = validityDateParts[0]
  const expirationYear = validityDateParts[1]

  const getCardNumber = () => {
    const onlyNumbers = debitCard.number.match(/\d+/g)
    if (onlyNumbers) return onlyNumbers.join([])
    return ''
  }

  const cardNumber = getCardNumber()

  const AuthorizationBraspag = useSelector(({ AuthorizationBraspag: data }) => data);
  const { callApi } = usePipeContext()

  const getIPAddress = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      
      setIpAddress(data.ip);
    } catch (err) {
      console.error('Error fetching IP address:', error);
    }
  }
  
  useEffect(() => {
    getIPAddress();
  }, []);

  //Ao carregar o componente, chamaremos a API
  useEffect(() => {
    window.localStorage.removeItem('braspagAuthenticationInfos');
    deleteCookie('braspagAuthenticationInfos');
  
    window.localStorage.removeItem('BraspagErrorInfo');
    deleteCookie('BraspagErrorInfo');

    //Bater no endpoint da braspag
    callApi({
      symbol: 'FETCH_BRASPAG_AUTHORIZATION',
      alias: generateUUID()
    });
  }, []);

  useEffect(() => {
    if (AuthorizationBraspag?.finishRequests && !AuthorizationBraspag?.isError) {
        setAccessToken(AuthorizationBraspag.authorizationBraspag.access_token)
        setIsLoadingBraspagInput(false); //Apenas para liberar os botões de compra
    } else if (AuthorizationBraspag?.isError) {
      setIsBraspagAuthorizeError(false)
      window.location.reload(); // REQUISITO
    }
  }, [AuthorizationBraspag?.finishRequests])


  useEffect(() => {
    let braspagAutheticationInfoInterval, braspagErrorInfoInterval;

    if (AuthorizationBraspag?.finishRequests) {
      braspagAutheticationInfoInterval = setInterval(() => {
        let rawBraspag = null;

        rawBraspag = window.localStorage.getItem('braspagAuthenticationInfos');
        if (!rawBraspag) getCookie('braspagAuthenticationInfos');

        const braspagAuthenticationInfos = JSON.parse(rawBraspag);

        if (braspagAuthenticationInfos) {
          setIsLoadingBraspagConfirmationModal(false);
          clearInterval(braspagAutheticationInfoInterval);
          handlePurchaseDebit(braspagAuthenticationInfos);
        }

      }, 1000);

      braspagErrorInfoInterval = setInterval(() => {
        let rawBraspagErrorInfo = null;

        rawBraspagErrorInfo = window.localStorage.getItem('BraspagErrorInfo');
        if (!rawBraspagErrorInfo) getCookie('BraspagErrorInfo');

        setIsLoadingBraspagConfirmationModal && setIsLoadingBraspagConfirmationModal(false);
        rawBraspagErrorInfo && handleShowError(rawBraspagErrorInfo);
      }, 1000);
    }

    return () => {
      clearInterval(braspagAutheticationInfoInterval);
      clearInterval(braspagErrorInfoInterval);
    };
  }, [AuthorizationBraspag?.finishRequests, AuthorizationBraspag?.isError]); //Alterar para finishRequests && hasError

  const getMerchantUrl = () => {
    const rawUrl = window.location.href;
    const urlObject = new URL(rawUrl);
    return urlObject.origin;
  };

  return (AuthorizationBraspag?.finishRequests && accessToken) && (
    <div id='bp_container_authenticate'>
      <input name='auth' className='bpmpi_auth' type='hidden' value={true} />
      <input name='accessToken' className='bpmpi_accesstoken' type='hidden' value={accessToken} />
      <input name='orderNumber' className='bpmpi_ordernumber' type='hidden' value='123456' />
      <input name='currency' className='bpmpi_currency' type='hidden' value='BRL' />
      <input name='amount' className='bpmpi_totalamount' type='hidden' value={formatToCent.toString()} />
      <input name='installments' className='bpmpi_installments' type='hidden' value='1' />
      <input name='paymentMethod' className='bpmpi_paymentmethod' type='hidden' value='Debit' />
      <input name='cardNumber' className='bpmpi_cardnumber' type='hidden' value={cardNumber} />
      <input name='cardExpirationMonth' className='bpmpi_cardexpirationmonth' type='hidden' value={expirationMonth} />
      <input name='cardExpirationYear' className='bpmpi_cardexpirationyear' type='hidden' value={expirationYear} />
      <input name='productCode' className='bpmpi_order_productcode' type='hidden' value={'PHY'} />
      <input name='merchantUrl' className='bpmpi_merchant_url' type='hidden' value={getMerchantUrl()} />
      <input name='merchantNewCustomer' className='bpmpi_merchant_newcustomer' type='hidden' value={true} />
      <input name='contactName' className='bpmpi_billto_contactname' type='hidden' value={customer.name} />
      <input name='phoneNumber' className='bpmpi_billto_phonenumber' type='hidden' value={`55${phoneNumber.replace(/\s+/g, '')}`} />
      <input name='email' className='bpmpi_billto_email' type='hidden' value={customer.email} />
      <input name='street1' className='bpmpi_billto_street1' type='hidden' value={billingAddress && billingAddress.street ? billingAddress.street : ''} />
      <input name='street2' className='bpmpi_billto_street2' type='hidden' value={billingAddress && billingAddress.complement ? billingAddress.complement : ''} />
      <input name='city' className='bpmpi_billto_city' type='hidden' value={billingAddress && billingAddress.city ? billingAddress.city : ''} />
      <input name='state' className='bpmpi_billto_state' type='hidden' value={billingAddress && billingAddress.state ? billingAddress.state : ''} />
      <input name='zipcode' className='bpmpi_billto_zipcode' type='hidden' value={billingAddress && billingAddress.zipCode ? billingAddress.zipCode : ''} />
      <input name='country' className='bpmpi_billto_country' type='hidden' value='BR' />
      <input name='ipAddress' className='bpmpi_device_ipaddress' type='hidden' value={ipAddress} />
      <input name='deviceChannel' className='bpmpi_device_channel' type='hidden' value='Browser' />
    </div>
  )
}

CreateBraspagInput.propTypes = {
  customer: PropTypes.object,
  billingAddress: PropTypes.object,
  paymentPoints: PropTypes.number,
  debitCard: PropTypes.object,
  setIsLoadingBraspagInput: PropTypes.func,
  setIsLoadingBraspagConfirmationModal: PropTypes.func,
  handleShowError: PropTypes.func,
  handlePurchaseDebit: PropTypes.func
}

export default CreateBraspagInput
